import * as React from "react";

const RightArrowIcon = (props) => {
  const {
    size = 40,
    color = "#FC3F3F",
    groupClass = "",
    ...rest
  } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 39 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <foreignObject x="0" y="0" width="40" height="40">
        <div
          style={{
            backdropFilter: "blur(1px)",
            WebkitBackdropFilter: "blur(1px)",
            clipPath: "url(#bgblur_0_2126_37909_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>

      <g className={groupClass} filter="url(#filter0_d_2126_37909)">
        <rect
          x="4"
          y="4"
          width="28"
          height="28"
          rx="6"
          fill="white"
          fillOpacity="0.3"
          shapeRendering="crispEdges"
        />

        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.2416 23.8373C19.0275 23.6147 19.0214 23.2471 19.2278 23.0163L23.1943 18.5806L11.5385 18.5806C11.2411 18.5806 11 18.3207 11 18C11 17.6793 11.2411 17.4194 11.5385 17.4194L23.1943 17.4194L19.2278 12.9837C19.0214 12.7529 19.0275 12.3853 19.2416 12.1627C19.4557 11.9401 19.7966 11.9468 20.003 12.1776L24.8491 17.597C25.0503 17.8219 25.0503 18.1781 24.8491 18.403L20.003 23.8224C19.7966 24.0532 19.4557 24.0599 19.2416 23.8373Z"
          fill={color}
        />
      </g>

      <defs>
        <filter
          id="filter0_d_2126_37909"
          x="0"
          y="0"
          width="40"
          height="40"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2" dy="2" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2126_37909"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2126_37909"
            result="shape"
          />
        </filter>

        <clipPath id="bgblur_0_2126_37909_clip_path">
          <rect x="4" y="4" width="28" height="28" rx="6" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default RightArrowIcon;
